// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__mABXW","rowsWrapper":"style_rowsWrapper__2AVcF","rowWrapper":"style_rowWrapper__3P0-J"};